//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('SearchFilterCachingServiceHelper', [
    function() {
            /**
             * Helper to build an id from a pageIdentifier and filterSetName. This assumes that the combination of the two will be a unique identifier
             * for cached filter sets.
             * @param {string} pageIdentifier
             * @param {string} filterSetName
             * @returns {string}
             */
      this.buildCacheId = (pageIdentifier, filterSetName) => {
        return `${pageIdentifier}:${filterSetName}`;
      };
    },
  ]);
})();
